export const inputCharactersLimitText = 'You can type up to 1000 characters';
